import { render } from "./ContentHeader.vue?vue&type=template&id=6825d476&scoped=true"
import script from "./ContentHeader.vue?vue&type=script&lang=js"
export * from "./ContentHeader.vue?vue&type=script&lang=js"

import "./ContentHeader.vue?vue&type=style&index=0&id=6825d476&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6825d476"]])

export default __exports__